import { render, staticRenderFns } from "./BaseImgPreView.vue?vue&type=template&id=efbd8ff8"
import script from "./BaseImgPreView.vue?vue&type=script&lang=js"
export * from "./BaseImgPreView.vue?vue&type=script&lang=js"
import style0 from "./BaseImgPreView.vue?vue&type=style&index=0&id=efbd8ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports